// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"fa6ad4ce","336":"113348a2","340":"0e546c89","346":"7e15bb77","542":"95dd7f13","767":"45bffbe5","896":"dba71b20","973":"c43a2e4b"}[chunkId] + ".chunk.css";
};